var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33301 9.99967H8.66634V11.333H7.33301V9.99967ZM7.33301 4.66634H8.66634V8.66634H7.33301V4.66634ZM7.99301 1.33301C4.31301 1.33301 1.33301 4.31967 1.33301 7.99967C1.33301 11.6797 4.31301 14.6663 7.99301 14.6663C11.6797 14.6663 14.6663 11.6797 14.6663 7.99967C14.6663 4.31967 11.6797 1.33301 7.99301 1.33301ZM7.99967 13.333C5.05301 13.333 2.66634 10.9463 2.66634 7.99967C2.66634 5.05301 5.05301 2.66634 7.99967 2.66634C10.9463 2.66634 13.333 5.05301 13.333 7.99967C13.333 10.9463 10.9463 13.333 7.99967 13.333Z",
    fill: "#C80000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDownloadIcon);
export default __webpack_public_path__ + "static/media/ErrorDownloadIcon.eff90bbe.svg";
export { ForwardRef as ReactComponent };